import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextInputField from "./TextInputField/index";
import { useGetUserQuery, useUpdateProfileMutation } from "../../api/profile";
import Swal from "sweetalert2";

const MyProfileFormSection = () => {
  const { data: user, isLoading } = useGetUserQuery();
  const [updateProfile, { isLoading: updatingUser }] = useUpdateProfileMutation()
  const [userData, setUserData] = useState({
    fullName: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (user)
      setUserData({
        fullName: user.data.profile.fullName,
        email: user.data.profile.email,
        phone: user.data.profile.phone,
      });
  }, [user]);

  const handleUpdateProfile = () => {
    console.log(userData)
    updateProfile(userData).then((res) => {
      if (res.error) {
        console.log(res.error)
        Swal.fire("Failed!!", res.error.data.message)
      } else {
        Swal.fire("Success", "Updated Successfully")
      }
    })
  }

  return (
    <>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Box width="100%" height="100%" sx={{ p: 2 }}>
          <Typography fontSize="24px" fontWeight="600">
            My Profile
          </Typography>
          <Grid container>
            <Grid item container xs={12} md={9}>
              <Grid item xs={12} md={2.3} my="5px">
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ alignItems: { xs: "center", md: "flex-end" } }}
                >
                  <Box width="120px" height="120px">
                    <img
                      src="images/profilepic.svg"
                      alt="profilepic"
                      width="100%"
                      height="100%"
                    />
                  </Box>
                  <Box>
                    <Button
                      variant="outlined"
                      fullWidth
                      sx={{
                        mt: "5px",
                        borderColor: "#80B3B0",
                        color: "#2B817B",
                        textTransform: "capitalize",
                        minWidth: "127px",
                        "&:hover": { borderColor: "#80B3B0" },
                      }}
                    >
                      Edit dishes
                    </Button>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={9} my="5px" minHeight="300px">
                <Box display="flex" justifyContent="flex-start" p="10px">
                  <Box width="100%" height="100%">
                    <Box width="100%" height="100%">
                      <TextInputField
                        label="User Name"
                        name="username"
                        value={userData.fullName}
                        placeholder="Enter User Name"
                        fullWidth
                        lableFontSize="18px"
                        lableFontWeight="500"
                        onChangeHandler={(e) =>
                          setUserData({ ...userData, fullName: e.target.value })
                        }
                      />
                      <TextInputField
                        label="Email"
                        name="email"
                        value={userData.email}
                        placeholder="Enter email address"
                        fullWidth
                        lableFontSize="18px"
                        lableFontWeight="500"
                        onChangeHandler={(e) =>
                          setUserData({ ...userData, email: e.target.value })
                        }
                      />
                      <TextInputField
                        label="Phone Number"
                        name="phonenumber"
                        value={userData.phone}
                        placeholder="Enter Phone Number"
                        fullWidth
                        lableFontSize="18px"
                        lableFontWeight="500"
                        onChangeHandler={(e) =>
                          setUserData({ ...userData, phone: e.target.value })
                        }
                      />

                      {[1, 2].map((currItem, index) => (
                        <Box
                          border="1px solid #E1E1E6"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          borderRadius="4px"
                          p="16px"
                          my="10px"
                        >
                          <Box>
                            <Typography fontSize="20px" fontWeight="600">
                              Food Preferences
                            </Typography>
                            <Typography
                              fontSize="14px"
                              fontWeight="400"
                              color="#9EA3AE"
                            >
                              Choose your food preferences
                            </Typography>
                          </Box>
                          <Box width="24px" height="24px">
                            <img
                              src="images/arrow-right.svg"
                              alt="arrowRightIcon"
                              width="100%"
                              height="100%"
                            />
                          </Box>
                        </Box>
                      ))}

                      <Button
                        sx={{
                          mt: "20px",
                          mb: "10px",
                          p: "11px 20px 11px 20px",
                          color: "white",
                          bgcolor: "#2B817B",
                          textTransform: "capitalize",
                          "&:hover": { bgcolor: "#2B817B" },
                        }}

                        onClick={handleUpdateProfile}
                      >
                        Save Changes
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default MyProfileFormSection;

//         <Grid item xs={12} md={8}>
//         <Box display="flex" flexWrap="wrap" border="1px solid tomato" minHeight="300px">
//             <Box width="125px"  border="1px solid blue" minHeight="300px" display="flex" flexDirection="column" alignItems="center" my="5px">
//                 <Box width="120px" height="120px">
//                     <img src="images/profilepic.svg" alt="profilepic" width="100%" height="100%" />
//                 </Box>
//                 <Box>
//                     <Button variant="outlined" fullWidth sx={{mt:"5px",borderColor:"#80B3B0",color:"#2B817B",textTransform:"capitalize",minWidth:"127px",'&:hover':{borderColor:"#80B3B0"}}}>Edit dishes</Button>
//                 </Box>
//             </Box>
//             <Box width="350px" ml="10px" border="1px solid blue" minHeight="300px" my="5px">
//                 <p>right div</p>
//             </Box>
//         </Box>
// </Grid>
